export const salaryRoute = {
  path: "/accounting/salary",
  name: "salary",
  component: () => import("@/ui/accounting/salary-list.vue")
};